export const isPrivateListing = listing => {
  const { listingType } = listing.attributes.publicData || {};
  return listingType === 'one-seat';
};
